import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectFertilizerSchemaExists } from 'services/schemas/selectors';

export interface Props {
    children: React.ReactElement;
    FallbackComponent?: React.ReactElement;
}

function FertilizerSchemaExistsGate(props: Props): React.ReactElement | null {
    const { children, FallbackComponent } = props;

    const fertilizerSchemaExists = useSelector(selectFertilizerSchemaExists);

    if (!fertilizerSchemaExists) {
        return FallbackComponent || null;
    }

    return children;
}

export default FertilizerSchemaExistsGate;
